import { defineComponent as _defineComponent } from 'vue'
import { RegistrationStepKeys } from '@/app/helpers/registration/flow';
import { getServices } from '@/app/services';
import { useAuthStore } from '@/app/store/authStore';
import { BaseIndividual, Client, Individual, PublicComplianceCase } from 'ah-api-gateways';
import LoadingOverlay from 'ah-common-lib/src/common/components/overlays/LoadingOverlay.vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { isArray } from 'lodash';
import { forkJoin } from 'rxjs';
import { computed, onBeforeMount, ref } from 'vue';
import CompanyDetailsReview from './forms/CompanyDetailsReview.vue';
import ContactDetailsReview from './forms/ContactDetailsReview.vue';
import DocumentsReview from './forms/DocumentsReview.vue';
import TradingDetailsReview from './forms/TradingDetailsReview.vue';
import ClientMembersReview from './forms/ClientMembersReview.vue';
import SignatoryDetailsReview from './forms/SignatoryDetailsReview.vue';
import ClientRejectionModal from './modals/ClientRejectionModal.vue';
import { useIndividualSettingsStore } from '@/app/store/individualSettingsModule';


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingReview',
  props: {
    client: null,
    allowEdit: { type: [Array, Boolean], default: () => [] },
    successBtnLabel: { default: 'Approve' }
  },
  emits: ["application-accepted", "update:client"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'application-accepted'): void;
  (e: 'update:client', value: Client): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { client: Client, allowEdit: RegistrationStepKeys[] | boolean, successBtnLabel: string };





function checkEditAllowence(step: RegistrationStepKeys) {
  return props.allowEdit === true || (isArray(props.allowEdit) && props.allowEdit.includes(step));
}

const requestManager = useRequestManager().manager;

const services = getServices();

const authStore = useAuthStore();

const individualStore = useIndividualSettingsStore();

const clientId = computed(() => authStore.loggedInIdentity?.client?.id);

const isOwner = computed(() => authStore.loggedInIdentity?.owner);

const complianceCase = ref<PublicComplianceCase>();

const individuals = ref<Individual[]>([]);

const ubos = ref<BaseIndividual[]>();

const applicant = ref<Individual>();

const documents = computed(() => individualStore.clientDocuments ?? []);

const owner = computed({
  get: () => individuals.value?.find((i) => i.owner !== false)!,
  set: (value: Individual) => {
    if (individuals.value && value) {
      const index = individuals.value.findIndex((i) => i.owner !== false);
      if (index > -1) {
        individuals.value.splice(index, 1, value);
      } else {
        individuals.value.push(value);
      }
    }
  },
});

function approve() {
  emit('application-accepted');
}

function reject() {
  requestManager
    .currentOrNew('rejectClient', services.client.rejectTermsAndConditions(clientId.value!))
    .subscribe(() => authStore.logout());
}

function loadData() {
  if (clientId.value) {
    individualStore.loadClientDocuments(true);
    requestManager
      .sameOrCancelAndNew(
        'loadData',
        forkJoin([
          services.compliance.getClientComplianceCase(clientId.value),
          services.compliance.listUbos(clientId.value),
          services.individual.listIndividuals({ clientId: clientId.value }),
        ])
      )
      .subscribe(([caseObj, ubosList, individualsList]) => {
        complianceCase.value = caseObj;
        ubos.value = ubosList.list;
        individuals.value = individualsList.list.filter((ind) => ind.user?.id !== (props.client.createdBy as any)?.id);
        applicant.value = individualsList.list.find((ind) => ind.user?.id === (props.client.createdBy as any)?.id);
      });
  }
}

onBeforeMount(loadData);

return { __sfc: true,props, emit, checkEditAllowence, requestManager, services, authStore, individualStore, clientId, isOwner, complianceCase, individuals, ubos, applicant, documents, owner, approve, reject, loadData, RegistrationStepKeys, LoadingOverlay, CompanyDetailsReview, ContactDetailsReview, DocumentsReview, TradingDetailsReview, ClientMembersReview, SignatoryDetailsReview, ClientRejectionModal }
}

})